var _defs, _rect, _br, _text, _rect2, _br2, _text2, _rect3, _text3, _rect4, _text4, _rect5, _text5, _rect6, _text6, _rect7, _br3, _br4, _text7, _rect8, _br5, _text8, _rect9, _br6, _br7, _text9, _rect10, _text10, _rect11, _text11, _rect12, _text12, _rect13, _br8, _br9, _text13, _rect14, _br10, _text14, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayoutHelper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "491px",
    height: "561px",
    viewBox: "-0.5 -0.5 491 561",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2020-05-26T09:27:52.521Z\" agent=\"5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.138 Safari/537.36\" etag=\"9UvG_Tz_kOiLzUzSjsER\" version=\"13.1.3\" type=\"google\" pages=\"2\"><diagram id=\"WXUO1iPDDGqg9sy7IZOM\" name=\"Mod\\xE8le\">3Vhdb9owFP01SNtDJccmiXlsU2irlW4rndo9TSZ2SFYTI8cplF8/hzh8JXRUC6RM4sE598bmnnN9fZ0W8sazK0kmYV9QxlsQ0FkLXbYgtNoQtrIfoK854nbcHBjJiBqnFTCI5syAwKBpRFmy4aiE4CqabIK+iGPmqw2MSCmmm26B4JurTsiIlYCBT3gZfYyoCnMUQ3eFX7NoFBYrW04nt4xJ4WwiSUJCxXQNQt0W8qQQKh+NZx7jGXkFL/l7vR3W5R+TLFb7vNCfP0a9a+JeO6IX4FuAA7t/ZtR5ITw1AfeJ1IxAh+tJL4ZSj0bZ6IqkfshMJOq1oEeKNKYsWwFop2kYKTaYED+zTnVCaCxUY66fLD0MIs49wYVcvIsoYTjwNZ4oKZ7ZmsXxMRsG2lKO0YT9wqRiszXIxHzFxJgp+apdjBUCw79JQKvQY7qS0zFQuKakXYDEZNBoOfWKZD0wPL+Dc7Qv55dSaD5PkHMHfTTO27s4ByFJT5LjJYFvcIzcCpIPxrGzk+OhXuv0GXYaZ9gtMdzV0XmodX5ecw4HAXP8Soap2xkCcKAcxk0zjEsMf4s0hbp/YUWzcPo0L8tsYzR33k7k7YPwluTGjsz6smP0Js0IA9v7nZMIHkqYou1eU+Ym1hTQ1FeRiMvcf5pINo4W6mC52iMgYSlnY03N55p1CeAOXZyhYzv16ILaW7q4ZV2WN5SjbBjLKuniidjnaVKtCmUy/osqpXcW7joAwEnmmi56T0DT/HalWKxH3mKuJAsx9mW+KfUDi/NT/n8Q2waNi73zVrYSAoxqKHqhkNFcz0i48W+kz1pWszeqIDxuFSxfF7yvdw/dux/15jf2WXV+D7Hdtms6ZLbzG6E989tya+D3t395/3wT3n8ZzCDAF/DnL+vhrFzMyvldx+X3Y+S3bTeY35X8l+vLv7RfB/hMcZz2y3YbbL8EiF/4EznnFsbq/m7emzx9r9gYnpCSJRMRUxKrpOLUTqLFtvHDXKJ6T2BqM0zbVTpgOETOodqtqg1SVaHQ+3XQj6tPrgvb2odr1P0D</diagram><diagram id=\"_wSXBCJihMUoYj_EkJPN\" name=\"Page-2\">5VbdbpswGH0aLiNhuxC4TFnaSVu7StlUpXfGfIBVg5ljBtnTz4BJwoi2dsrWi11hn+/H+Jxjg0Oior1VtMrvZALCwW7SOuSdgzFyiWceHbIfEM/DA5ApntikI7Dh32GstGjNE9hNErWUQvNqCjJZlsD0BKNKyWaalkoxXbWiGcyADaNijj7yROcDGuDlEX8PPMvHlZEfDpGCjsl2J7ucJrI5gcjaIZGSUg+joo1AdOSNvDwXgB8Dvt1u44cFgqcPdyu2GJrdvKbksAUFpb5sa39o/Y2K2vK1NktExFmtNNht6/3IpZJ1mUDXz3XIdZNzDZuKsi7aGPcYLNeFMDNkhikXIpJCqr6WJBSClBl8p5V8hpOIzwKI065CltoaCIVmbt8NlIb2JzF/wwQ6yGN8DbIArfamznbBvlXUWhoFdt4cDUKWFstPzDHWUevJ7ND6yLsZWOpfIcNyJsMDNzybUwejxf8TLTz/rbUIfn0kfGFe4DpWEzX8r3V3C/SsLXY9bSuTgMKq7bkb42aUdc+PdOgYqu6eukzPW1qz/LI+SVPw2VmfJMswdt039Am+mvsEuWd8QvDfMgrCM6dEn+4/r++/XFaEgMF5EeLAu/L+pQjkBSLgc4f1T0Qw0+O3tY+d/KGQ9Q8=</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 560,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 280,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Marge", _br || (_br = /*#__PURE__*/React.createElement("br", null)), "Gauche")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 284,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Marge...")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 0,
    width: 60,
    height: 560,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 280,
      marginLeft: 431
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Marge", _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null)), "Droite")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 284,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Marge...")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0,
    width: 370,
    height: 60,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 368,
      height: 1,
      paddingTop: 30,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Marge haute")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 34,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Marge haute")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 500,
    width: 370,
    height: 60,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 368,
      height: 1,
      paddingTop: 530,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Marge bas")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 534,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Marge bas")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 370,
    height: 60,
    fill: "#ffe6cc",
    stroke: "#d79b00",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 368,
      height: 1,
      paddingTop: 90,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Ent\xEAte")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 94,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Ent\xEAte")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 440,
    width: 370,
    height: 60,
    fill: "#ffe6cc",
    stroke: "#d79b00",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 368,
      height: 1,
      paddingTop: 470,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Pied de page")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 474,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Pied de page")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 60,
    height: 320,
    fill: "#ffe6cc",
    stroke: "#d79b00",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 280,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Ent\xEAte", _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null)), "Lat\xE9rale", _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null)), "Gauche")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 284,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Ent\xEAte...")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 150,
    width: 210,
    height: 60,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 208,
      height: 1,
      paddingTop: 180,
      marginLeft: 141
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Introduction", _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null)), "(premi\xE8re page seulement)")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 184,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Introduction...")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 380,
    width: 210,
    height: 60,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 208,
      height: 1,
      paddingTop: 410,
      marginLeft: 141
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Conclusion", _br6 || (_br6 = /*#__PURE__*/React.createElement("br", null)), "(derni\xE8re page seulement)", _br7 || (_br7 = /*#__PURE__*/React.createElement("br", null)), "(\xE0 la suite du contenu, pas ancr\xE9 en bas)")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 414,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Conclusion...")))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 20,
    height: 320,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)rotate(-90 130 280)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 318,
      height: 1,
      paddingTop: 280,
      marginLeft: "-29px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Marge contenu gauche")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 284,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Marge contenu gauche")))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 210,
    width: 210,
    height: 170,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 208,
      height: 1,
      paddingTop: 295,
      marginLeft: 141
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "CONTENU")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 299,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "CONTENU")))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 120,
    width: 20,
    height: 320,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)rotate(-90 360 280)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 318,
      height: 1,
      paddingTop: 280,
      marginLeft: 201
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Marge contenu Droite")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 284,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Marge contenu Droite")))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 120,
    width: 60,
    height: 320,
    fill: "#ffe6cc",
    stroke: "#d79b00",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 280,
      marginLeft: 371
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Ent\xEAte", _br8 || (_br8 = /*#__PURE__*/React.createElement("br", null)), "Lat\xE9rale", _br9 || (_br9 = /*#__PURE__*/React.createElement("br", null)), "Droite")))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 284,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Ent\xEAte...")))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 120,
    width: 210,
    height: 30,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 208,
      height: 1,
      paddingTop: 135,
      marginLeft: 141
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Correspondants", _br10 || (_br10 = /*#__PURE__*/React.createElement("br", null)), "(si coch\xE9)")))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 139,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Correspondants..."))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://desk.draw.io/support/solutions/articles/16000042487",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutHelper);
export default __webpack_public_path__ + "static/media/layout-helper.3a3ca6ec24b6c6498534c8959f768156.svg";
export { ForwardRef as ReactComponent };